// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2d76d982","644":"1f1e01c2"}[chunkId] + ".chunk.js";
};